
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import fetch from "auth/FetchInterceptor";

export const assignCarToClient = createAsyncThunk("client/asigncar", async(
data,{ rejectWithValue }
)=>{
try{
const params = new URLSearchParams();
console.log("carId inside slice:",data.carId);
console.log("test updated 4");
if(data.clientId) params.append("clientId",data.clientId);

 const response = await fetch({
        url: `/client/asigncar/${data.clientId}`,
        method: "put",
        data
      });
      console.log("response:",response);
      return response;
      
}catch (error) {
      return rejectWithValue(
        error?.response?.data?.error || "Erreur"
      );
     
    }
});

export const getAllClients = createAsyncThunk(
  "client/getAllClients",
  async (
    { page = 1, limit = 10, fullName, phoneNumber, status },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
      });

      if (fullName) params.append("fullName", fullName);
      if (phoneNumber) params.append("phoneNumber", phoneNumber);
      if (status) params.append("status", status);

      const response = await fetch({
        url: `/client/getAll?${params.toString()}`,
        method: "get",
      });

      return response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.error || "Erreur lors du chargement"
      );
    }
  }
);

export const addClient = createAsyncThunk(
  "client/addClient",
  async (data, { rejectWithValue }) => {
    try {
      const response = await fetch({
        url: "/client/create",
        method: "post",
        data,
      });
      return response;
    } catch (error) {
      const status = error?.response?.status;
      if (status === 400) {
        return rejectWithValue("Ce client existe déjà.");
      }
      return rejectWithValue("Erreur inconnue");
    }
  }
);

export const deleteClient = createAsyncThunk(
  "client/deleteClient",
  async (id, { rejectWithValue }) => {
    try {
      await fetch({ url: `/client/delete/${id}`, method: "delete" });
      return id;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.error || "Erreur à la suppression"
      );
    }
  }
);

export const updateClient = createAsyncThunk(
  "client/updateClient",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await fetch({
        url: `/client/update/${id}`,
        method: "put",
        data,
      });
      return { id, updated: response.data };
    } catch (error) {
      const status = error?.response?.status;
      if (status === 400) {
        return rejectWithValue("Ce client existe déjà.");
      }
      if (status === 401) {
        return rejectWithValue("Ancien mot de passe incorrect.");
      }
      return rejectWithValue("Erreur inconnue");
    }
  }
);
export const toggleClientStatus = createAsyncThunk(
  "client/toggleClientStatus",
  async ({ id, newStatus }, { rejectWithValue }) => {
    try {
      const response = await fetch({
        url: `/client/updateStatus/${id}`,
        method: "put",
        data: { status: newStatus },
      });
      return { id, updatedStatus: response.data.status };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.error ||
          "Erreur lors de la mise à jour du statut"
      );
    }
  }
);
const clientSlice = createSlice({
  name: "client",
  initialState: {
    clients: [],
    total: 0,
    page: 1,
    totalPages: 1,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetClientsState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllClients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllClients.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.clients = payload.data;
        state.total = payload.total;
        state.page = payload.page;
        state.totalPages = payload.totalPages;
      })
      .addCase(getAllClients.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
    builder
      .addCase(addClient.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addClient.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.success = true;
        state.clients.unshift(payload);
        state.total += 1;
      })
      .addCase(addClient.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
        state.success = false;
      });
    builder
      .addCase(assignCarToClient.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(assignCarToClient.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.success = true;
        state.clients.unshift(payload);
        state.total += 1;
      })
      .addCase(assignCarToClient.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
        state.success = false;
      });
    builder
      .addCase(deleteClient.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteClient.fulfilled, (state, { payload: deletedId }) => {
        state.loading = false;
        state.success = true;
        state.clients = state.clients.filter((m) => m.id !== deletedId);
        state.total -= 1;
      })
      .addCase(deleteClient.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
        state.success = false;
      });
    builder
      .addCase(updateClient.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateClient.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.success = true;
        const idx = state.clients.findIndex((m) => m.id === payload.id);
        if (idx !== -1) {
          state.clients[idx] = payload.updated;
        }
      })
      .addCase(updateClient.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
        state.success = false;
      });
    builder
      .addCase(toggleClientStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(toggleClientStatus.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.success = true;

        const idx = state.clients.findIndex((m) => m.id === payload.id);
        if (idx !== -1) {
          state.clients[idx].status = payload.updatedStatus;
        }
        message.success("Statut du client mis à jour avec succès !");
      })
      .addCase(toggleClientStatus.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
        state.success = false;
        message.error(payload || "Erreur lors de la mise à jour du statut");
      });
  },
});

export const { resetClientsState } = clientSlice.actions;
export default clientSlice.reducer;
